export default __webpack_public_path__ + "static/rocketBackground-8543f228fb7464877baf5a7be2e4d310.png";